import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useSiteData } from '../context/SiteDataContext';

const CGVPage = () => {
  const { cgv } = useSiteData();

  return (
    <div className="min-h-screen bg-black font-sans" data-testid="cgv-page">
      <Helmet>
        <title>Conditions Générales de Vente | Ecotint & Reprog</title>
        <meta name="description" content="Conditions Générales de Vente d'Ecotint & Reprog - Reprogrammation moteur et films solaires à Eugénie les Bains." />
      </Helmet>
      <Header />

      <section className="pt-28 pb-12 sm:pt-32 sm:pb-16 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-8">
            Conditions Générales de <span className="text-red-500">Vente</span>
          </h1>
          <div className="prose prose-invert max-w-none" data-testid="cgv-content">
            {(cgv || '').split('\n').map((line, i) => {
              if (!line.trim()) return <div key={i} className="h-4" />;
              if (line.startsWith('CONDITIONS GÉNÉRALES')) {
                return null; // Skip the main title, we have the h1
              }
              if (line.match(/^Article \d+/)) {
                return <h2 key={i} className="text-lg sm:text-xl font-bold text-white mt-8 mb-3">{line}</h2>;
              }
              if (line.startsWith('- ')) {
                return (
                  <div key={i} className="flex items-start gap-2 ml-4 mb-1.5">
                    <span className="text-red-500 mt-1.5 flex-shrink-0">&#8226;</span>
                    <span className="text-white/60 text-sm sm:text-base leading-relaxed">{line.substring(2)}</span>
                  </div>
                );
              }
              if (line.startsWith('Dernière mise à jour')) {
                return <p key={i} className="text-white/30 text-xs mt-10 pt-6 border-t border-white/10">{line}</p>;
              }
              return <p key={i} className="text-white/60 text-sm sm:text-base leading-relaxed mb-2">{line}</p>;
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CGVPage;
